import { LOG_TAGS, withDeviceTag } from "@origin-digital/tal-client-common";

// Re-exported so every logger.* call site in this package can `import { LOG_TAG }
// from "./logTag"` without needing to know the shared package's key name.
// Previously three separate, inconsistent tags depending on which file was
// logging: "[stepup-guard]", "[GetJwtSilently]", "[Silent Auth]".
// Also carries the "[web]"/"[native]" device tag — see withDeviceTag()'s doc
// comment for why it's baked in here rather than at each call site.
export const LOG_TAG = withDeviceTag(LOG_TAGS.originAuth);
